import Button from 'components/Button/Button'
import { Input } from 'components/Input'
import Select from 'components/Select'
import {
  TableItemContainer,
  TableItemBody,
} from 'components/Table/Table.styled'
import React from 'react'
import { useAppState } from 'store'
import { CategoryColor } from './AppointmentCategoryModal.styled'

const AppointmentCategoryItem: React.FC = () => {
  const { reservationColors } = useAppState(state => state.appointments)
  return (
    <TableItemContainer>
      <TableItemBody style={{ padding: '1rem' }}>
        <Input value="Contract Court" />
      </TableItemBody>
      <TableItemBody justify="center" style={{ padding: '1rem' }}>
        <CategoryColor hex="blue" />
      </TableItemBody>
      <TableItemBody style={{ padding: '1rem' }}>
        <Select autocomplete options={reservationColors} />
      </TableItemBody>
      <TableItemBody style={{ padding: '1rem' }}>
        <Select autocomplete options={reservationColors} />
      </TableItemBody>
      <TableItemBody style={{ padding: '1rem' }}>
        <Button
          text="Remove"
          variant="secondary"
          preset="filled"
          size={'small'}
        />
      </TableItemBody>
    </TableItemContainer>
  )
}

export default AppointmentCategoryItem
